import { ListView, type ListViewProps } from "@carbon6/c6-frontend-design";
import { isTextNode, TableEmptyState } from "./TableEmptyState";

/**
 * 앱의 빈 결과 형태와 한국어 기본 문구를 입힌 c6 `ListView`.
 *
 * 빈 결과는 `HatDataTable` 의 빈 상태와 같은 면이다(`TableEmptyState`, docs/rules.md §19). 호출부는
 * `emptyMessage` 에 문장만 넘긴다. 요소 노드를 넘기면 그대로 둔다. 그 노드가 형태를 소유한다.
 *
 * 대기와 조회 실패는 c6 가 그린다. c6 `ListView` 는 그 두 자리에 노드를 받지 않는다. 실패의 다시 시도
 * 버튼 문구만 이 래퍼가 한국어로 둔다. c6 기본값은 영어다.
 */
export function HatListView<T>({
  emptyMessage = "표시할 항목이 없습니다.",
  retryLabel = "다시 시도",
  ...props
}: ListViewProps<T>) {
  return (
    <ListView
      {...props}
      retryLabel={retryLabel}
      emptyMessage={
        isTextNode(emptyMessage) ? <TableEmptyState>{emptyMessage}</TableEmptyState> : emptyMessage
      }
    />
  );
}
